/**
 * Voice input. One entry point, so callers never choose an implementation.
 */
export { SpeechError, UnavailableRecogniser } from './stt.js';
export type { SpeechErrorKind, SpeechHandlers, SpeechRecogniser, SpeechResult } from './stt.js';
export { WebSpeechRecogniser, isWebSpeechAvailable } from './webSpeech.js';
export { PushToTalk } from './pushToTalk.js';
export type { PushToTalkEvents, PushToTalkOptions, TransmitOutcome } from './pushToTalk.js';
export { DEFAULT_TRANSMIT_LIMITS, TransmitRules } from './transmit.js';
export type { TransmitLimits, TransmitPhase, TransmitState } from './transmit.js';

import { UnavailableRecogniser, type SpeechRecogniser } from './stt.js';
import { WebSpeechRecogniser, isWebSpeechAvailable } from './webSpeech.js';

/**
 * The best recogniser available here.
 *
 * Today that is Web Speech or nothing; a server STT drops in as another branch without any
 * caller changing. Falling back to the null object rather than returning null means the "speech
 * is unavailable" path is the same code path as the "speech failed" one, and only has to work
 * once.
 */
export function createRecogniser(locale: string): SpeechRecogniser {
  if (!isWebSpeechAvailable()) return new UnavailableRecogniser();
  // Web Speech wants a regional tag; the locale is a bare language.
  const lang = locale === 'tr' ? 'tr-TR' : 'en-US';
  return new WebSpeechRecogniser({ lang });
}
